import { __assign } from "tslib";
import { FontSizes, FontWeights } from '@fluentui/react';
export var CoherenceDataGridColumnWidth;
(function (CoherenceDataGridColumnWidth) {
    CoherenceDataGridColumnWidth[CoherenceDataGridColumnWidth["min"] = 120] = "min";
    CoherenceDataGridColumnWidth[CoherenceDataGridColumnWidth["middle"] = 200] = "middle";
    CoherenceDataGridColumnWidth[CoherenceDataGridColumnWidth["max"] = 360] = "max";
})(CoherenceDataGridColumnWidth || (CoherenceDataGridColumnWidth = {}));
export var regularHeaderStyles = function (theme) {
    return {
        root: {
            paddingTop: 0,
            selectors: {
                '.ms-DetailsHeader-cellName': {
                    color: theme.palette.neutralPrimary,
                    fontSize: FontSizes.size14,
                    fontWeight: FontWeights.semibold
                },
                '.ms-DetailsHeader-cellTitle': {
                    paddingLeft: '12px',
                    paddingRight: '12px'
                },
                '.ms-DetailsHeader-cell': {
                    paddingTop: '15px',
                    paddingBottom: '13px',
                    paddingLeft: '16px',
                    paddingRight: '16px'
                },
                '.ms-DetailsHeader-cellIsCheck': {
                    paddingTop: '15px',
                    paddingBottom: '13px',
                    paddingLeft: '0px',
                    paddingRight: '0px'
                }
            }
        }
    };
};
export var looseHeaderStyles = function (theme) {
    return __assign({}, regularHeaderStyles(theme));
};
export var compactHeaderStyles = function (theme) {
    return __assign({}, regularHeaderStyles(theme));
};
export var regularRowStyle = function (theme) {
    return {
        root: {
            selectors: {
                '.ms-DetailsRow-cell > div > span': {
                    userSelect: 'text',
                    cursor: 'text'
                },
                '.is-selected': {
                    selectors: {
                        '&:focus:hover': {
                            background: theme.palette.neutralLight
                        }
                    }
                }
            }
        },
        cell: {
            minHeight: '40px',
            paddingTop: '9px',
            paddingBottom: '9px',
            paddingLeft: '12px',
            paddingRight: '12px'
        }
    };
};
export var looseRowStyle = function (theme) {
    return __assign(__assign({}, regularRowStyle(theme)), { root: {
            selectors: __assign(__assign({}, regularRowStyle(theme).root.selectors), { '.ms-DetailsRow-cellCheck': {
                    marginTop: '2px'
                } })
        }, cell: {
            minHeight: '48px',
            paddingTop: '13px',
            paddingBottom: '13px'
        } });
};
export var compactRowStyle = function (theme) {
    return __assign(__assign({}, regularRowStyle(theme)), { cell: {
            minHeight: '32px',
            paddingTop: '5px',
            paddingBottom: '5px'
        } });
};
export var compactListStyle = function (theme) {
    return {
        root: {
            selectors: {
                '.ms-List-cell': {
                    selectors: {
                        '.ms-DetailsRow': {
                            borderBottom: '1px solid ' + theme.palette.neutralLight + ' !important'
                        }
                    }
                },
                '.ms-List-cell:last-child': {
                    selectors: {
                        '.ms-DetailsRow': {
                            borderBottom: '1px solid ' + theme.palette.neutralLight + ' !important'
                        }
                    }
                }
            }
        }
    };
};
export function getStyles(props) {
    var theme = props.theme, headerWrapper = props.headerWrapper, headerStyles = props.headerStyles, rowStyles = props.rowStyles, listStyles = props.listStyles, compactMode = props.compactMode, isLoading = props.isLoading, isScrollable = props.isScrollable;
    return {
        cellRightAligned: {
            textAlign: 'right'
        },
        cellCenterAligned: {
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%'
        },
        headerRightAligned: {
            selectors: {
                '.ms-DetailsHeader-cellTitle': {
                    float: 'right'
                }
            }
        },
        headerCenterAligned: {
            selectors: {
                '.ms-DetailsHeader-cellTitle': {
                    justifyContent: 'center'
                }
            }
        },
        root: [isLoading && { marginTop: '10px' }, !isLoading && isScrollable && { height: '100%', position: 'relative' }],
        subComponentStyles: {
            header: __assign(__assign({}, headerStyles), { root: [
                    compactMode === 'loose'
                        ? looseHeaderStyles(theme).root
                        : compactMode === 'compact'
                            ? compactHeaderStyles(theme).root
                            : regularHeaderStyles(theme).root,
                    headerStyles === null || headerStyles === void 0 ? void 0 : headerStyles.root
                ] }),
            row: __assign(__assign({}, rowStyles), { root: [
                    compactMode === 'loose'
                        ? looseRowStyle(theme).root
                        : compactMode === 'compact'
                            ? compactRowStyle(theme).root
                            : regularRowStyle(theme).root,
                    rowStyles === null || rowStyles === void 0 ? void 0 : rowStyles.root
                ], cell: [
                    compactMode === 'loose'
                        ? looseRowStyle(theme).cell
                        : compactMode === 'compact'
                            ? compactRowStyle(theme).cell
                            : regularRowStyle(theme).cell,
                    rowStyles === null || rowStyles === void 0 ? void 0 : rowStyles.cell
                ] }),
            list: __assign(__assign({}, listStyles), { root: [
                    compactMode === 'compact' && compactListStyle(theme).root,
                    listStyles === null || listStyles === void 0 ? void 0 : listStyles.root,
                    {
                        overflowX: 'auto'
                    }
                ] })
        },
        headerWrapper: __assign({ position: 'sticky', top: 0, zIndex: 1 }, headerWrapper),
        scrollableStyles: { height: '100%', position: 'relative' }
    };
}
//# sourceMappingURL=CoherenceDataGrid.styles.js.map